// Mock data for ShobhaWithShubhra - Luxury Wedding & Event Planning

export const brand = {
  name: "Shobha with Shubhra",
  short: "SwS",
  monogram: "SS",
  tagline: "Design, Planning & Delivery of Exceptional Weddings & Events",
  intro: "CURATING EMOTIONS",
  founder: "Shubhra",
  email: "contact@shobhawithshubhra.com",
  phone: "+1 (262) 527-4592",
  whatsapp: "+1 (262) 527-4592",
  location: "Wisconsin, USA",
  instagram: "https://www.instagram.com/shobhawithshubhra?igsh=dXN4ZjhjdnRwc29w&utm_source=qr",
  facebook: "https://www.facebook.com/profile.php?id=61559370720422",
};

export const heroImages = [
  "https://i.imgur.com/Pg7YEOH.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/60m0sfm1_dea6f43b-9664-4037-87bd-965dfa049d75.jpg",
  "https://i.imgur.com/ffM4f3A.jpeg",
];

export const founderImage =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/9g8v21gb_IMG_8677-EDIT.webp";

export const teamImage =
  "https://images.pexels.com/photos/32315685/pexels-photo-32315685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const philosophyImage =
  "https://images.pexels.com/photos/17057034/pexels-photo-17057034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const approachImage =
  "https://images.pexels.com/photos/37828118/pexels-photo-37828118.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const servicesImage =
  "https://images.pexels.com/photos/16074970/pexels-photo-16074970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const featureImage =
  "https://images.pexels.com/photos/11566306/pexels-photo-11566306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1600";

export const trustedBy = [
  "THE LEELA",
  "Taj Palace",
  "ITC MAURYA",
  "Oberoi",
  "FOUR SEASONS",
  "And many more…",
];

export const asSeenIn = [
  { name: "VOGUE", style: "font-serif tracking-[0.25em]" },
  { name: "HELLO!", style: "font-sans font-black" },
  { name: "BRIDES TODAY", style: "font-serif italic" },
  { name: "HARPER'S BAZAAR", style: "font-serif tracking-widest" },
  { name: "TATLER", style: "font-sans tracking-[0.4em]" },
];

export const eventServices = [
  {
    id: "event-full-design",
    title: "Full Design",
    kicker: "AESTHETIC DIRECTION",
    excerpt:
      "Party design, top to bottom — colorful displays, lighting, tablescapes, themed backdrops, and every detail in between, all planned so you can just show up and celebrate.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/l0xuevi6_0dabb0c8-01be-4fc2-a496-5d6aab910ff2.jpg",
  },
  {
    id: "event-mood-board",
    title: "Vision Studio",
    kicker: "INSTANT DESIGN PREVIEW",
    excerpt:
      "Not sure how your event should feel? Describe your vibe — palette, style, mood — and Ayaan sketches a full concept board in seconds. Personally reviewed by Shubhra, and the perfect starting point for your Full Design engagement.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/ma19z2h6_IMG_9229.webp",
    cta: { label: "Try free preview", action: "mood-board" },
  },
  {
    id: "event-planning",
    title: "Planning",
    kicker: "END-TO-END STRATEGY",
    excerpt:
      "Custom budgets, timeline coordination, venue recommendations, and decor styling for an effortless celebration.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/la6ykcvb_IMG_4341%20Copy.webp",
  },
  {
    id: "event-management",
    title: "Event Management",
    kicker: "SEAMLESS EXECUTION",
    excerpt:
      "Full day-of décor coverage: on-site installation, styling, coordination, and real-time problem-solving by our dedicated decoration team so you can relax and be a guest at your own celebration.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/o4f82ok5_IMG_0063%20%281%29.jpg",
    objectPosition: "25% 25%",
  },
];

export const weddingServices = [
  {
    id: "wedding-full-design",
    title: "Full Design",
    kicker: "AESTHETIC DIRECTION",
    excerpt:
      "A cohesive visual story from color palettes and florals to mandap styling, lighting and tablescapes — every detail composed with intention.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/lgwimkme_35b815f1-4e68-4ae1-9be0-adddf00bd463.jpg",
  },
  {
    id: "wedding-mood-board",
    title: "Vision Studio",
    kicker: "INSTANT DESIGN PREVIEW",
    excerpt:
      "Curious how your wedding could look? Describe your vibe — palette, florals, mandap style — and Ayaan sketches a personal concept board in seconds. Reviewed by Shubhra, and the ideal first step before commissioning your Full Design.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/60m0sfm1_dea6f43b-9664-4037-87bd-965dfa049d75.jpg",
    cta: { label: "Try free preview", action: "mood-board" },
  },
  {
    id: "wedding-planning",
    title: "Wedding Planning",
    kicker: "THE JOURNEY BEGINS",
    excerpt:
      "From engagement to vidaai — pheras, sangeet, mehendi and reception, crafted with heart and precision so every ritual feels effortless.",
    image: "https://i.imgur.com/susWeqk.jpeg",
    objectPosition: "center 30%",
  },
  {
    id: "wedding-sangeet",
    title: "Haldi, Mehendi & Sangeet",
    kicker: "PRE-WEDDING NIGHTS",
    excerpt:
      "Cinematic staging, layered florals and choreographed lighting for the celebrations that set the tone for your entire wedding weekend.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/lw9j0fbw_a45ee8ca-3047-411f-ab5c-4ac9b707e70f.jpg",
  },
  {
    id: "wedding-decoration",
    title: "High-End Decoration",
    kicker: "IMMERSIVE ENVIRONMENTS",
    excerpt:
      "Statement mandaps, floral installations and bespoke stage design that transform any Wisconsin venue into a heirloom-worthy backdrop.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/60m0sfm1_dea6f43b-9664-4037-87bd-965dfa049d75.jpg",
  },
];

// Backwards compatibility: legacy `services` combined array (used only if imported directly).
export const services = [...weddingServices, ...eventServices];

export const portfolio = [
  {
    id: "p1",
    title: "Whimsical Romance",
    location: "Milwaukee, Wisconsin",
    tag: "WEDDING & ANNIVERSARY",
    image: "https://i.imgur.com/rJS8Fvv.jpeg",
    objectPosition: "center 30%",
  },
  {
    id: "p2",
    title: "Marigold Mandap",
    location: "Sheboygan",
    tag: "WEDDING & ANNIVERSARY",
    image:
      "https://images.pexels.com/photos/34079355/pexels-photo-34079355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "p3",
    title: "Midnight Garden",
    location: "GreenBay",
    tag: "WEDDING & ANNIVERSARY",
    image: "https://i.imgur.com/hQevNHp.jpeg",
  },
  {
    id: "p4",
    title: "Haldi",
    location: "Green Bay",
    tag: "WEDDING & ANNIVERSARY",
    image:
      "https://images.pexels.com/photos/37331162/pexels-photo-37331162.jpeg",
  },
  {
    id: "p5",
    title: "Sangeet Nights",
    location: "Wisconsin",
    tag: ["EVENT", "WEDDING & ANNIVERSARY"],
    image: "https://i.imgur.com/zIldkrQ.jpeg",
  },
  {
    id: "p6",
    title: "The Grand Feast",
    location: "Wisconsin",
    tag: "DINING",
    image:
      "https://images.pexels.com/photos/17057034/pexels-photo-17057034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "p7",
    title: "Birthday",
    location: "Milwaukee",
    tag: "BIRTHDAY",
    image: "https://i.imgur.com/ID9P12K.jpeg",
    objectPosition: "10% center",
  },
  {
    id: "p8",
    title: "Baby Shower",
    location: "Sheboygan",
    tag: "BABY SHOWER",
    image: "https://i.imgur.com/YPzrFh3.jpeg",
  },
  {
    id: "p9",
    title: "Cake & Confetti",
    location: "Wisconsin",
    tag: "BIRTHDAY",
    image: "https://i.imgur.com/ClZeiEs.jpeg",
  },
  {
    id: "p12",
    title: "Golden Milestone",
    location: "Wisconsin",
    tag: "BIRTHDAY",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_elegant-event-design-1/artifacts/6rp4r9mt_IMG_6927.jpg",
  },
  {
    id: "p10",
    title: "Graduation",
    location: "Wisconsin",
    tag: "GRADUATION",
    image: "https://i.imgur.com/hZztQD7.jpeg",
  },
  {
    id: "p11",
    title: "Reception",
    location: "Wisconsin",
    tag: "WEDDING & ANNIVERSARY",
    image: "https://i.imgur.com/i04lY5N.jpeg",
  },
];

export const testimonials = [
  {
    id: "t1",
    quote:
      "I cannot put into words how absolutely magical our day turned out to be. Our wedding exceeded all expectations and was a dream from beginning to end!",
    author: "SHIV & SHRUTI",
    image: "https://i.imgur.com/vCSxerK.jpeg",
  },
  {
    id: "t2",
    quote:
      "I'm almost lost for words — just wow, wow, wow! I had an absolute blast and really couldn't have done it without your team. It was THE party of the century!",
    author: "KATE",
    image: "https://i.imgur.com/RWkH9Kq.jpeg",
  },
  {
    id: "t3",
    quote:
      "Your creative flair, meticulous planning and attention to detail blew us away — a spectacle in every sense of the word. It's Magic Shubhra from now on!",
    author: "SHIV & SHRUTI",
    image:
      "https://images.pexels.com/photos/32315685/pexels-photo-32315685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "t4",
    quote:
      "If you want a flawless, stunning event, hire Shubhra! She took our exact baby shower theme and absolutely blew us away with her execution. She is hyper-organized, professional, and genuinely cares about making the day unforgettable. Our guests are still talking about how beautiful the setup was! She is worth every single penny.",
    author: "AJIT & RUBAL",
    image: "https://i.imgur.com/PRdEoim.jpeg",
  },
  {
    id: "t5",
    quote:
      "When it comes to creating flawless, high-end celebrations, Shobha with Shubhra sets the gold standard. They took our concept for this milestone 10th birthday and turned it into an absolutely breathtaking reality. From their meticulous coordination to their world-class professionalism, their passion shines through in every single detail. Weeks later, our guests are still raving about the beautiful atmosphere. Hiring them is the best investment you can make.",
    author: "ARNAB & APARNA",
    image: "https://i.imgur.com/TbiqPo4.jpeg",
  },
  {
    id: "t6",
    quote:
      "For an exquisite, seamlessly coordinated event, Shobha with Shubhra is truly in a league of their own. They effortlessly brought our vision for this milestone 25th wedding anniversary to life, elevating it into a magnificent experience.",
    author: "GIRISH & ARCHANA",
    image: "https://i.imgur.com/fMGUSuy.jpeg",
  },
  {
    id: "t7",
    quote:
      "If you want a breathtaking, perfectly coordinated milestone party, Shobha with Shubhra sets the ultimate benchmark. They flawlessly mapped out our vision for Shubhi's Bollywood-themed 16th birthday, creating a uniquely magical atmosphere. Their premium event planning, professionalism, and sharp artistic flair were beautifully evident in every detail of the final display.",
    author: "PUJA",
    image: "https://i.imgur.com/tiXMabL.jpeg",
  },
  {
    id: "t8",
    quote:
      "Working with Shubhra was an absolute joy. She took my graduation vision and transformed it into a celebration I'll remember for a lifetime. I could truly relax and enjoy every moment because her planning team handled every detail with flawless care.",
    author: "VASU",
    image: "https://i.imgur.com/Fwy1CIU.jpeg",
  },
];

export const journal = [
  {
    id: "j1",
    title: "A Marigold-Draped Mandap in Lake Country",
    date: "June 2025",
    excerpt:
      "Behind the scenes of an intimate ceremony where every petal was placed with intention.",
    image:
      "https://images.pexels.com/photos/34079355/pexels-photo-34079355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    id: "j2",
    title: "Designing Sangeet Nights That Feel Cinematic",
    date: "May 2025",
    excerpt:
      "How lighting, layered florals and sound design bring an unforgettable atmosphere to life.",
    image:
      "https://i.imgur.com/zIldkrQ.jpeg",
  },
  {
    id: "j3",
    title: "The Tablescape: Where Guests Fall in Love",
    date: "April 2025",
    excerpt:
      "Tablescapes are more than décor — they are the first hello and the last goodbye.",
    image:
      "https://images.pexels.com/photos/17057034/pexels-photo-17057034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
];
